import React from 'react'
import { Col, Row, FormGroup, Label, Button, Alert } from 'reactstrap'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { I18n } from 'react-redux-i18n'
import { getCompanies } from '../../redux/actions/companies'
import { InlineInput, UserLanguageField } from '../Form'
import { uploadFiles } from '../../utils'

import { FILE_MAX_SIZE_PROFILE } from 'constants/filesMaxSize'
import userAct from '../../redux/actions/user'
import UploadFiles from '../UploadFiles/'
import FilePreview from '../UploadFiles/FilePreview'
import { signup } from '../../api'

class Index extends React.Component {
  constructor(props) {
    super(props)
    this.userAct = bindActionCreators(Object.assign({}, userAct, { getCompanies }), props.dispatch)

    this.state = {
      user: Object.assign({}, props.user),
      errors: {},
      alerts: {},
      updatingPassword: false,
      uploadingFiles: false,
    }

    this.updateUser = this.updateUser.bind(this)
    this.getCompany = this.getCompany.bind(this)
    this.handleResetPassword = this.handleResetPassword.bind(this)
    this.handleUploadFile = this.handleUploadFile.bind(this)
    this.handleRemoveFile = this.handleRemoveFile.bind(this)
  }

  componentDidMount() {
    if (!Object.keys(this.props.companies)) {
      this.userAct.getCompanies()
    }
  }

  getCompany(companies, user) {
    if (this.company) return this.company
    this.company = companies._id ? companies : companies[user.company]
    return this.company
  }

  handleChange(event, param) {
    const user = Object.assign({}, this.state.user)

    user[param] = event.target.value

    this.setState({ user })
  }

  handleSelectChange(val, param) {
    const user = Object.assign({}, this.state.user)

    if (param === 'locale') user[param] = val.value
    else user[param] = val

    this.setState({ user }, this.updateUser)
  }

  handleResetPassword() {
    this.setState({ updatingPassword: true }, () => {
      const user = this.props.user

      signup.emailChangePassword({ email: user.email }).then(({ status }) => {
        if (status === 200)
          return this.setState((prevState) => ({
            alerts: Object.assign({}, prevState.alerts, { password: true }),
            updatingPassword: false,
          }))
      })
    })
  }

  handleUploadFile(files) {
    this.setState({ uploadingFiles: true })
    return new Promise((resolve, reject) => {
      const company = this.getCompany(this.props.companies, this.props.user)
      const companyType = company.type
      const companyToken = this.props.user.hash

      return uploadFiles({
        user: this.props.user,
        files,
        typeUpload: 'userFile',
        companyType,
        companyToken,
      })
        .then((attachments) =>
          this.setState({ uploadingFiles: false }, () => {
            const user = Object.assign({}, this.state.user)
            user.picture = attachments[0].urlLong
            this.setState({ user }, this.updateUser)
            resolve(attachments)
          })
        )
        .catch(() => this.setState({ uploadingFiles: false }, reject))
    })
  }

  updateUser() {
    const { user } = this.state

    const newUser = Object.assign({}, user)
    if (!newUser.email || !newUser.name || !newUser._id) return

    delete newUser.password

    this.userAct.updateOperator(newUser)
  }

  handleRemoveFile() {
    const e = { target: { value: '' } }
    this.handleChange(e, 'picture')
  }

  render() {
    const { user, alerts, updatingPassword, uploadingFiles } = this.state
    return (
      <Row className='user-profile'>
        <Col xs={12}>
          <InlineInput
            className='user-name'
            onDone={(fields) => {
              const user = Object.assign({}, this.state.user, fields)
              this.setState({ user: user }, this.updateUser)
            }}
            fields={{
              name: { value: user.name, type: 'text' },
              lastname: { value: user.lastname, type: 'text' },
            }}
          >
            {user.name} {user.lastname} <i className='fa fa-pencil' />
          </InlineInput>
          <div className='user-role'>{I18n.t(`roles_${user.role}`)}</div>
        </Col>
        <div className='user-profile-sections'>
          <Col className='user-profile-section' xs={12}>
            <div className='section-title'>{I18n.t('dashboard_preferences-and-settings')}</div>
            <div className='section-subtitle'>{I18n.t('dashboard_language-and-currency')}</div>
            <FormGroup>
              <UserLanguageField
                name='locale'
                id='user_locale'
                selected={user.locale}
                onChange={(e) => this.handleSelectChange(e.target, 'locale')}
              />
            </FormGroup>

            <div className='section-subtitle'>{I18n.t('dashboard_change-password')}</div>
            <FormGroup row>
              <Label xs={4}>{I18n.t('dashboard_password')}</Label>
              <Col xs={8}>
                <Button color='primary' onClick={this.handleResetPassword} disabled={updatingPassword}>
                  {I18n.t('dashboard_restore-password')}
                </Button>
              </Col>
              {alerts.password && (
                <Col xs={12} className='animated fadeIn mt-3'>
                  <Alert color='success'>{I18n.t('dashboard_email-send-to-restore-password')}</Alert>
                </Col>
              )}
            </FormGroup>
          </Col>
          <Col className='user-profile-section' xs={12}>
            <div className='section-title'>{I18n.t('dashboard_account-data')}</div>
            <FormGroup row>
              <Label xs={4}>{I18n.t('dashboard_email')}</Label>
              <Col xs={8}>
                <span>{user.email}</span>
              </Col>
            </FormGroup>

            <FormGroup>
              <Label>{I18n.t('dashboard_profile-picture')}</Label>
              <Col xs={12}>
                {!user.picture && (
                  <UploadFiles
                    uploading={uploadingFiles}
                    uploadFiles={(files) => this.handleUploadFile(files)}
                    multiple={false}
                    maxSize={FILE_MAX_SIZE_PROFILE}
                    labelSize={I18n.t('placeholder_profile_max_file_size')}
                    messageErrorSize={I18n.t('error_profile_file_too_big')}
                    cancelButton={false}
                    accept='image/*'
                  />
                )}
                {user.picture && <FilePreview url={user.picture} shortUrl={user.picture} type='image/*' onRemoveFile={this.handleRemoveFile} />}
              </Col>
            </FormGroup>
          </Col>
        </div>
      </Row>
    )
  }
}

export default connect((state) => ({
  user: state.user,
  companies: state.companies,
  locale: state?.i18n?.locale
}))(Index)
